
import OImage from "@/components/base/image/OImage"
import mapping, { jobTypeMapping, productIconMapping } from "@/helpers/mapping"
import { mdiChevronRight } from "@mdi/js"
import Card from "@/components/base/card/Card"
const TYPE = mapping.mapValue(jobTypeMapping)
export default {
    name: "LimitReachedOverlay",
    components: {
        Card,
        OImage,
        JobCard: () => import("@/components/job/card/JobCard"),
        Button: () => import("@/components/base/Button"),
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        job: {
            type: Object,
            default: null,
        },
        limit: {
            type: Number,
            required: true,
        },
    },
    icons: {
        mdiChevronRight,
    },
    data: () => ({
        image: null,
        text: "",
        progress: 0,
        isAnimationCompleted: false,
    }),
    computed: {
        elements() {
            return [
                {
                    text: "Auf Oabat veröffentlichen...",
                    image: require("@/assets/images/logos/logo-small.svg"),
                },
            ]
        },
        animationStepDuration() {
            const MAX_TOTAL = 10000 //ms
            const MAX_STEP = 2000 //ms
            const steps = this.elements.length
            if (steps <= 3) return MAX_STEP
            return MAX_TOTAL / steps
        },
        jobType() {
            return TYPE(this.job.type_id)
        },
        themeColors() {
            const theme = this.job.theme?.theme
            if (!theme) return
            return []
                .concat(
                    theme.backgroundPrimary,
                    theme.backgroundSecondary,
                    theme.buttonPrimary,
                    theme.buttonSecondary
                )
                .filter((color) => {
                    return this.isValidFireworkColor(color)
                })
        },
        headline() {
            if (Number(this.job.type_id) === 1) {
                return `Ihre ${this.jobType} wurde gespeichert.`
            }
            return `Ihr ${this.jobType} wurde gespeichert.`
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal) this.animate()
            },
        },
    },
    methods: {
        wait(duration) {
            return new Promise((resolve) => setTimeout(resolve, duration))
        },
        getIcon(slug) {
            return productIconMapping.find((el) => el.slug === slug).icon
        },
        async animate() {
            await this.wait(10)
            this.progress = 10
            await this.wait(500)
            for (let i = 1; i <= this.elements.length; i++) {
                const { text, image } = this.elements[i - 1]
                this.text = text
                this.image = image
                this.progress = (i / this.elements.length) * 100
                await this.wait(this.animationStepDuration)
            }
            await this.wait(500)
            this.isAnimationCompleted = true
        },
    },
}
